module.exports = __webpack_public_path__ + "img/xaklogin4.8e06df48.png";